import axios from 'axios';
import {
	ADMIN_BOKKINGS_URL, ADMIN_POINT_OF_INTEREST,
	ADMIN_RESELLERS_URL,
	PROVIDERS_ADMIN_MARKETPLACE_EXPERIENCES_URL,
	PROVIDERS_URL
} from '../../../../../config';
import { DataTableHelper } from '../../../../../utilities/helpers/DataTableHelper';
import {AmountFormatHelper} from "../../../../../utilities/helpers/AmountFormatHelper";

export function getProviders(sortParam, pageSize, pageNumber, searchParam, filters) {
	let url =
		PROVIDERS_URL +
		DataTableHelper.prepareParameters(
			sortParam,
			pageSize,
			pageNumber,
			null,
			searchParam,
		);

	if (filters) {
		const extra = [];
		Object.keys(filters).forEach((key) => {
			const values = filters[key];
			if (Array.isArray(values) && values.length > 0) {
				extra.push(`${key}=${values.join(',')}`);
			}
		});
		if (extra.length > 0) {
			url += (url.includes('?') ? '&' : '?') + extra.join('&');
		}
	}

	return axios.get(url);
}

export function changeProviderStatus(providerId, verify) {
	return axios.post(PROVIDERS_URL + '/' + providerId + '/verify', {
		verify: verify
	});
}

export function changeDocumentStatus(documentId, status) {
	return axios.put(PROVIDERS_URL + '/legal-files/' + documentId, {
		status: status
	});
}

export function getLegalFiles(documentId) {
	return axios.get(PROVIDERS_URL + '/legal-files/' + documentId, {
		responseType: 'blob'
	});
}

export function getPoisToMatchFile() {
	return axios.get(ADMIN_POINT_OF_INTEREST + '/locations-to-match', {
		responseType: 'blob',
		validateStatus: (status) => status === 200, // Accept only successful responses
	});
}

export function uploadMatchedPoisFile(file, iteration) {
	const formData = new FormData();
	formData.append('iteration', iteration);
	formData.append('file', file, file.name);
	return axios.post(ADMIN_POINT_OF_INTEREST + '/upload-matched-locations', formData)
}

export function getProviderDetails(id) {
	return axios.get(PROVIDERS_URL + '/' + id);
}

export function getResellers(id) {
	return axios.get(ADMIN_RESELLERS_URL + '/' + id);
}

export function getExperienceByProvider(providerId) {
	return axios.get(PROVIDERS_ADMIN_MARKETPLACE_EXPERIENCES_URL + '?provider_id=' + providerId + '&channel_id=2');
}

export function getMarketplaceExperienceByProvider(providerId) {
	return axios.get(PROVIDERS_ADMIN_MARKETPLACE_EXPERIENCES_URL + '?provider_id=' + providerId + '&channel_id=1');
}

export function getResaleCollectionByProvider(providerId) {
	return axios.get(PROVIDERS_ADMIN_MARKETPLACE_EXPERIENCES_URL + '?provider_id=' + providerId + '&channel_id=3');
}

export function updateCommission(providerId, commission) {
	return axios.put(`${PROVIDERS_URL}\\${providerId}\\upiria-commission`, {
		upiria_commission: AmountFormatHelper.deFormatAmount(commission)
	});
}

export function updateSubscription(providerId, isSubscription, plan) {
	return axios.put(`${PROVIDERS_URL}/${providerId}/subscription`, {
		is_subscription: Number(isSubscription),
		...(plan ? { plan } : {})
	});
}

export function updateProviderPlace(providerId, placeId) {
	return axios.put(`${PROVIDERS_URL}\\${providerId}\\set-place`, {
		place_id: placeId
	});
}

export function updateProviderGoogleBusinessProfileId(providerId, googleBusinessProfileId) {
	return axios.put(`${PROVIDERS_URL}\\${providerId}\\set-google-business-profile-id`, {
		google_business_profile_id: googleBusinessProfileId
	});
}

export const getProviderBookingList = (pId,pageSize,pageNumber) => {
	return axios.get(ADMIN_BOKKINGS_URL + `?start=${pageSize * pageNumber}&length=${pageSize}` + '&providers=' + pId)
}
